import { DaymadeDrawTypePlanCode } from 'constants/Draw';
import { ASSET_PREFIX } from 'utils/constants';

export const getTicketBackground = (code?: DaymadeDrawTypePlanCode) => {
  if (code === DaymadeDrawTypePlanCode.LITE) {
    return `${ASSET_PREFIX}/images/weekly-draw-tickets/lite-2.png`;
  }

  if (code === DaymadeDrawTypePlanCode.FREE) {
    return `${ASSET_PREFIX}/images/weekly-draw-tickets/freemium-2.png`;
  }

  if (code === DaymadeDrawTypePlanCode.PREMIUM) {
    return `${ASSET_PREFIX}/images/weekly-draw-tickets/premium-2.png`;
  }

  return `${ASSET_PREFIX}/images/daily-draw/empty-ticket.png`;
};
